import { render, staticRenderFns } from "./ProductGroupReport.vue?vue&type=template&id=83411cfe&"
import script from "./ProductGroupReport.vue?vue&type=script&lang=js&"
export * from "./ProductGroupReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
